/**
 * Builds the clipboard text for profile submission:
 * "DisplayName, addedId1addedId2..."
 *
 * Each paste is an add-only delta vs the profile's current badges. The sheet
 * loader unions every row for an email — later pastes never resend the full set.
 */
export const addedBadgeIDs = (enabledBadges: string[], previousBadgeIDs: readonly string[] = []): string[] => {
  if (previousBadgeIDs.length === 0) return enabledBadges;
  const prev = new Set(previousBadgeIDs);
  return enabledBadges.filter((id) => !prev.has(id));
};

/** Fold a paste's newly added IDs onto the badges already owned from earlier rows. */
export const accumulateOwnedBadgeIDs = (owned: readonly string[], added: readonly string[]): string[] => {
  if (added.length === 0) return [...owned];
  if (owned.length === 0) return [...new Set(added)];
  const seen = new Set(owned);
  const next = [...owned];
  for (const id of added) {
    if (seen.has(id)) continue;
    seen.add(id);
    next.push(id);
  }
  return next;
};

export const getClipboardText = (
  displayName: string,
  enabledBadges: string[],
  previousBadgeIDs: readonly string[] = []
): string => `${displayName}, ${addedBadgeIDs(enabledBadges, previousBadgeIDs).join('')}`;
